import React, { useState } from 'react';

const services = [
  { key: 'pancard', label: 'PAN Card (New & Update)' },
  { key: 'aadhar', label: 'Aadhar Update' },
  { key: 'passport', label: 'Passport Application' },
  { key: 'voterid', label: 'Voter ID (New & Update)' },
  { key: 'gazette', label: 'Gazette Name Change' },
];

const contentMap = {
  pancard: (
 
    <div className="p-4">
      <h1 className="text-2xl font-bold ">PAN CARD NEW & OLD PAN UPDATE</h1>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Introduction</h2>
        <p className="text-gray-700">
          The Permanent Account Number (PAN) card is a vital document issued by the Income Tax Department of India. 
          It serves multiple purposes, including serving as proof of identity, facilitating tax payments, and 
          tracking financial transactions. Due to its significant role in various financial dealings, preserving and 
          keeping the PAN card updated is essential.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Importance of Preserving the PAN Card</h2>
        <ul className="list-disc ml-6 text-gray-700 space-y-2">
          <li>
            <strong>Identity Verification:</strong> The PAN card is a widely accepted form of identification, 
            applicable for various purposes such as opening bank accounts, applying for loans, and verifying 
            identity in financial transactions.
          </li>
          <li>
            <strong>Tax Compliance:</strong> In India, filing income tax returns requires a PAN card. This card 
            provides taxpayers with a unique identifier, enabling the government to monitor income and tax 
            payments effectively.
          </li>
          <li>
            <strong>Financial Transactions:</strong> PAN is required for several financial transactions, including:
            <ul className="list-disc ml-6 mt-1 space-y-1">
              <li>Deposits exceeding ₹50,000 in a bank</li>
              <li>Purchasing or selling property</li>
              <li>Investing in mutual funds or stocks</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Necessity to Keep PAN Details Updated</h2>
        <ul className="list-disc ml-6 text-gray-700 space-y-2">
          <li>
            <strong>Change of Personal Information:</strong> Any change in personal details, such as name, address, 
            or marital status, must be updated in the PAN records to ensure consistency with other identification 
            documents.
          </li>
          <li>
            <strong>Avoiding Financial Penalties:</strong> Failing to update the PAN details may result in 
            discrepancies in tax filings or financial transactions, which can lead to possible penalties and 
            legal complications.
          </li>
          <li>
            <strong>Smooth Access to Services:</strong> An updated PAN facilitates seamless access to various 
            financial services. Banks and financial institutions require current PAN information to process 
            applications accurately.
          </li>
          <li>
            <strong>Digital Transactions:</strong> As digital transactions increase, having an updated PAN is 
            crucial for compliance with regulatory requirements, which helps prevent fraud and ensures secure 
            dealings.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">Conclusion</h2>
        <p className="text-gray-700">
          The PAN card is a crucial tool for tax compliance and an essential part of one's financial identity in 
          India. Maintaining its preservation and ensuring that all details are regularly updated is vital for 
          effective financial management and legal compliance. By keeping the PAN information current and secure, 
          individuals can avoid unnecessary complications and ensure access to a range of financial services 
          with ease.
        </p>
      </section>
    </div>
 

 

  ),
  aadhar: (
  <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">AADHAR UPDATING OF ADDRESS, MOBILE NUMBER, ETC</h2>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">Introduction</h3>
        <p className="text-gray-700">
          Aadhar is a 12-digit unique identification number issued by the Unique Identification Authority of India (UIDAI)
          that serves as a proof of identity and address for Indian residents. It is linked to various government services,
          benefits, and financial systems, making it crucial for individuals to ensure their Aadhar details, including address
          and contact number, are updated regularly.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">Importance of Keeping Aadhar Updated</h3>
        <ol className="list-decimal ml-6 space-y-3 text-gray-700">
          <li>
            <strong>Access to Government Services:</strong><br />
            Many government services and schemes, including subsidies, pensions, and welfare benefits, require a valid Aadhar.
            An updated address ensures that beneficiaries receive services at the correct location, preventing delays or disruptions.
          </li>
          <li>
            <strong>Financial Transactions:</strong><br />
            Aadhar is widely used for banking and financial transactions, including opening bank accounts and filing tax returns.
            Outdated information can hinder access to these services or lead to complications such as rejected applications or compliance issues.
          </li>
          <li>
            <strong>Avoiding Fraud:</strong><br />
            Keeping Aadhar details current helps protect against identity theft and fraud. Regular updates ensure that personal
            information is accurate, reducing the risk of unauthorized access to accounts or misuse of identification.
          </li>
          <li>
            <strong>Legal Compliance:</strong><br />
            Certain legal processes, such as obtaining a passport, applying for loans, or engaging in real estate transactions,
            require the Aadhar to reflect current and accurate information. Inaccuracies can lead to denials or legal complications.
          </li>
          <li>
            <strong>Seamless Digital Services:</strong><br />
            As India moves towards digital governance, updating Aadhar details facilitates smoother access to various online
            services, from e-governance platforms to digital payment systems.
          </li>
          <li>
            <strong>Notification of Changes:</strong><br />
            Individuals may change their residence or contact number due to various life events (e.g., marriage, job relocation).
            Keeping Aadhar updated ensures they can receive essential notifications from authorities, including important alerts
            regarding their data.
          </li>
        </ol>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">Document Submission</h3>
        <p className="text-gray-700">
          To make changes, individuals must provide supporting documentation that validates the new details
          (e.g., utility bills for address/mobile number changes).
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold mb-2">Conclusion</h3>
        <p className="text-gray-700">
          Regular updates to Aadhar details, including address, contact number, and other pertinent information,
          are essential for maintaining an accurate and viable identity within India's digital ecosystem. Given
          its critical role in accessing government services, financial transactions, and legal processes,
          individuals are encouraged to prioritise Aadhar updates to ensure smooth interactions and access to
          various benefits. By understanding and managing their Aadhar status, residents can protect their rights
          and streamline their dealings with the government and financial institutions.
        </p>
      </section>
    </div>
  ),
  passport: (
 <div className="p-4">
      <h2 className="text-2xl font-bold mb-4 ">Passport Application & Appointment Assistance</h2>
      <p className="text-gray-700 mb-6">
        Are you planning to travel abroad or need a new passport? Look no further!
        <br />
        We are here to simplify your journey towards obtaining a passport with our comprehensive assistance services.
      </p>

      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Our Services Include:</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li><strong>Consultation and Guidance:</strong> Expert advice on the required documentation for your passport application.</li>
          <li><strong>Document Verification:</strong> We help verify that your documents are accurate and complete to avoid delays.</li>
          <li><strong>Appointment Scheduling:</strong> We'll assist in scheduling your interview at the nearest passport office.</li>
          <li><strong>Application Support:</strong> Step-by-step help to ensure your form is filled out correctly and error-free.</li>
          <li><strong>Interview Preparation:</strong> Tips and info to help you prepare for your appointment.</li>
          <li><strong>Follow-Up Services:</strong> We'll help you track the status of your passport application post-interview.</li>
        </ul>
      </div>

      <div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Why Choose Us?</h3>
        <ul className="list-disc list-inside space-y-2 text-gray-700">
          <li><strong>Expert Knowledge:</strong> Our experienced team is well-versed in passport regulations and the application process.</li>
          <li><strong>Time-Saving:</strong> We handle the complexities so you can focus on your travel plans.</li>
          <li><strong>Personalized Service:</strong> Get customized assistance based on your unique situation.</li>
        </ul>
      </div>

      <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-600 text-blue-800 rounded">
        <p className="font-semibold">
          📅 Schedule your appointment or consultation today and let us assist you in obtaining your passport hassle-free!
        </p>
        <p className="mt-2">🌍 Safe travels await!</p>
      </div>
    </div>
  ),
  voterid: (
   <div className="p-4">
      <h2 className="text-2xl font-bold mb-4 "> VOTER ID APPLY NEW AND UPDATE OLD ONE</h2>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Introduction</h3>
        <p className="text-gray-700">
          The Voter ID card, officially known as the Electors Photo Identity Card (EPIC), is an essential document
          issued by the Election Commission of India (ECI). It serves as proof of identity and eligibility for
          participating in the electoral process, enabling citizens to exercise their right to vote.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Importance of Having a Voter ID</h3>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>
            <strong>Proof of Identity:</strong> The Voter ID card is a recognized form of identification that validates a
            person's identity during elections.
          </li>
          <li>
            <strong>Facilitates Voting:</strong> Possessing a Voter ID is mandatory for voting in elections and ensures a
            smoother verification process.
          </li>
          <li>
            <strong>Access to Government Services:</strong> It also serves as a valid ID for various government-related
            applications and processes.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Application for a New Voter ID</h3>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>
            <strong>Online Application:</strong> Apply through the National Voter Service Portal (NVSP) or the Election
            Commission website using Form 6 and submit ID, address, and age proofs.
          </li>
          <li>
            <strong>Offline Application:</strong> Visit your local election office or help centres to collect and submit
            the application form manually.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Keeping Voter ID Updated</h3>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>
            <strong>Change of Address:</strong> If you move, update your Voter ID to reflect your new constituency.
          </li>
          <li>
            <strong>Name Corrections:</strong> Any name change due to marriage or personal choice should be updated to
            keep your ID accurate.
          </li>
          <li>
            <strong>Regular Verification:</strong> Periodically check your registration status to ensure all details are
            up to date.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Conclusion</h3>
        <p className="text-gray-700">
          Having a Voter ID is crucial for exercising your right to vote and participating in government processes. By
          applying and updating your Voter ID, you maintain eligibility and ensure smooth participation in India’s
          democratic process.
        </p>
      </section>
    </div>
  ),
  gazette: (
   <div className="p-4">
      <h2 className="text-2xl font-bold  mb-4">
         NAME CHANGE GAZETTE FROM GOVERNMENT OF INDIA
      </h2>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-2">Introduction</h3>
        <p className="text-gray-700">
          A name change gazette notification is an official public announcement published in the Gazette of India,
          which serves as a legal document confirming a change of name for an individual or entity. This process
          is often required for various personal, legal, and administrative purposes.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-2">
          Importance of Gazette Notification for Name Change
        </h3>
        <ul className="list-disc pl-5 text-gray-700 space-y-2">
          <li>
            <strong>Legal Recognition:</strong> The gazette notification provides legal evidence of a name change,
            ensuring that the new name is recognized by government authorities, banks, educational institutions, and
            other organizations.
          </li>
          <li>
            <strong>Public Awareness:</strong> Publishing a name change in the gazette ensures that the change is
            made known to the public. This helps prevent confusion or legal issues that may arise from the use of
            multiple names.
          </li>
          <li>
            <strong>Official Documentation:</strong> Many official documents, such as passports, driver’s licenses,
            and educational certificates, may require an individual to provide proof of their name change. The
            gazette notification serves as a valid document in such cases.
          </li>
          <li>
            <strong>Facilitating Transactions:</strong> A gazette notification is often necessary for financial
            transactions and agreements, such as property sales, bank accounts, and mutual funds, where a discrepancy
            in name may lead to complications.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-2">
          Process of Obtaining a Name Change Gazette Notification
        </h3>
        <ol className="list-decimal pl-5 text-gray-700 space-y-2">
          <li>
            <strong>Affidavit Preparation:</strong> Individuals seeking a name change must prepare an affidavit
            declaring the change and the reasons for it, which they must sign in front of a notary.
          </li>
          <li>
            <strong>Publication in the Gazette:</strong> The affidavit is submitted to the relevant government
            department for publication in the Gazette. Depending on the jurisdiction, this may involve specific
            application forms and fees.
          </li>
          <li>
            <strong>Receiving the Gazette Copy:</strong> Once published, individuals receive a copy of the Gazette
            notification as concrete proof of the name change.
          </li>
        </ol>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-gray-700 mb-2">Conclusion</h3>
        <p className="text-gray-700">
          A name change gazette notification is an essential legal instrument for anyone wishing to change their name.
          It secures official recognition of the new name, facilitates smoother interactions with government authorities,
          and ensures consistency across all legal and personal documents. For individuals undergoing significant life
          changes, such as marriage or personal choice, obtaining a gazette notification is a critical step in establishing
          their new identity legally and publicly.
        </p>
      </section>
    </div>
  ),
};

const Documents = () => {
  const [selectedService, setSelectedService] = useState('pancard');

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Identity Document Services</h1>
       <p className="text-md text-justify text-[#444] mb-8">Our seasoned legal team, supported by our knowledgeable staff, offers comprehensive assistance to customers in navigating essential government processes, including obtaining PAN cards, updating Aadhaar information, applying for passports, securing Voter ID cards, and managing name changes through official gazette notifications. With extensive experience in handling these applications, our lawyers provide personalized guidance, ensuring that every form is accurately filled and that all requisite documentation is meticulously prepared. We take pride in delivering a streamlined experience, from initial consultation through to final approval, alleviating the complexities and potential challenges involved in dealing with government bureaucracy. By prioritizing efficiency and accuracy, we empower our clients to achieve their personal documentation needs with confidence and peace of mind.</p>
      {/* Tabs */}
      <div className="flex flex-wrap gap-4 mb-8">
        {services.map((service) => (
          <button
            key={service.key}
            onClick={() => setSelectedService(service.key)}
            className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
              selectedService === service.key
                ? 'bg-[#b7b7a1] text-white'
                : ' '
            }`}
          >
            {service.label}
          </button>
        ))}
      </div>

      {/* Dynamic Content */}
      <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 text-gray-800 leading-relaxed">
        {contentMap[selectedService]}
      </div>
    </div>
  );
};

export default Documents;
